// ** MUI Imports
import { alpha, type Theme } from '@mui/material/styles';

// ** Util Import
import { hexToRGBA } from '@erikdakoda/ui/shared/colorUtils';

const GlobalStyles = (theme: Theme) => {
  return {
    'html, body': {
      minHeight: '100%',
    },

    '#__next': {
      height: '100%',
    },

    /* Cross-browser scrollbar styles */
    '::-webkit-scrollbar': {
      width: 6,
      height: 6,
    },

    '::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },

    '::-webkit-scrollbar-thumb': {
      backgroundColor: alpha(theme.palette.customColors.main, 0.2),
      borderRadius: 10,
    },

    '::-webkit-scrollbar-thumb:hover': {
      backgroundColor: alpha(theme.palette.customColors.main, 0.6),
    },

    '::-webkit-scrollbar-corner': {
      backgroundColor: 'transparent',
    },

    /* Firefox scrollbar styles */
    html: {
      scrollbarWidth: 'thin',
      scrollbarColor: `${alpha(theme.palette.customColors.main, 0.2)} transparent`,
    },

    /* Additional cross-browser scrollbar support */
    '*': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${alpha(theme.palette.customColors.main, 0.2)} transparent`,
    },

    /* Hide number input arrows for WebKit */
    'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },

    /* Hide number input arrows for Firefox */
    'input[type="number"]': {
      MozAppearance: 'textfield',
    },

    'body[style^="padding-right"] .layout-navbar-and-nav-container::after': {
      content: '""',
      position: 'absolute' as const,
      left: '100%',
      top: 0,
      height: '100%',
      backgroundColor: hexToRGBA(theme.palette.background.paper, 0.85),
      width: '30px',
    },
    '.demo-space-x > *': {
      marginTop: '1rem !important',
      marginRight: '1rem !important',
      'body[dir="rtl"] &': {
        marginRight: '0 !important',
        marginLeft: '1rem !important',
      },
    },
    '.demo-space-y > *:not(:last-of-type)': {
      marginBottom: '1rem',
    },
    '.MuiGrid-container.match-height .MuiCard-root': {
      height: '100%',
    },

    '#nprogress': {
      pointerEvents: 'none',
      '& .bar': {
        left: 0,
        top: 0,
        height: 3,
        width: '100%',
        zIndex: 2000,
        position: 'fixed',
        backgroundColor: theme.palette.primary.main,
      },
    },

    '.code': {
      fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
      padding: '0.25rem 0.4rem 0.1rem',
      fontSize: '90%',
      color: 'rgb(233, 174, 126)',
      backgroundColor: 'rgb(17, 27, 39)',
      borderRadius: '0.1335rem',
    },
  };
};

export default GlobalStyles;
